import React from 'react';
import { Redirect, useHistory, withRouter } from 'react-router';
import queryString from 'query-string';
import AuthService from "../services/AuthService";

export class LoggedInPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            authenticatedUser: null,
            profile: null,
            error: null
        };
    }

    async componentDidMount() {
        console.log('processing logged in...');
        const values = queryString.parse(this.props.location.search);
        this.authService = await AuthService.getInstance();
        //console.log("values!", values);
        if (values.new) {
            console.log('new so signin redirect?');
            await this.authService.signinRedirect();
            this.setState({loaded: true, error: values.error, new: true});
            return;
        }
        if(values.error){
            console.log('error so signin redirect?');
            this.setState({loaded: true, error: values.error});
            return;
        }

        if (values.state && !values.error) {
            var user = await this.authService.signinRedirectCallback();
            if(user === null) {
                this.setState({loaded: true, error: "Sorry looks like you're logged in but not...?"});
                return;
            }
            this.setState({
                authenticatedUser: user
            });
            console.log('get my preferences with logged in user', user);
            const headers = new Headers();
            headers.append('Content-Type', 'application/json');
            headers.append('Authorization', `Bearer ${user.access_token}`);

            var prefsResponse = await window.fetch('api/UserPreferences/MyPreferences', {method: 'GET', headers: headers});
            if(prefsResponse.status === 200) {
                var prefs = await prefsResponse.json();
                this.setState({
                    loaded: true,
                    profile: prefs
                });
            }
            else {
                this.setState({loaded: true, profile: null});
                return;
            }
        }
    }

    render() {
        if(this.state.error) { 
            // if a redirect uri is currently stored - assume we can trust it TODO: may be security issue
            // const redirectUri = !!localStorage.getItem("redirectUri") ? localStorage.getItem("redirectUri") : null;
            // if(redirectUri && redirectUri != null){
            //     console.log('redirectUri from logged in page', redirectUri);
            //     this.props.history.push(redirectUri);
            //     return null;
            // }
            // else
                return 'Error logging in. ' + this.state.error;                        
        }

        if (!this.state.loaded)
            return "Loading...";

        if (!this.state.profile && !this.state.new) {
            return (<Redirect to='/Preferences' />);
        }

        if (this.state.authenticatedUser || this.state.error) {
            return (<Redirect to='/shipments' />);
        }

        return "Loading...";
    }
}

export default withRouter(LoggedInPage);